export default {
  KEY_ID: "rzp_live_LtruKVk4yYdQvv",
  SECRET_ID: "RapbEjJveE0wP2yNV2c7kriS",
};
